import { clearLocalStorage, setItem } from 'common/utilities/browser/localStorage/localStorage';
import { saveItem } from 'core/redux/actions/localStorage/localStorageActions';
import { loggedInUser, loggedOutUser } from 'core/redux/actions/user/userActions';
import type { AnyAction,Middleware } from 'redux';

const localStorageMiddleware: Middleware = () => (next) => (action: AnyAction) => {
  if (loggedOutUser.match(action) || loggedInUser.match(action)) {
    clearLocalStorage();
  }

  if (saveItem.match(action)) {
    setItem(action.payload.item);
  }

  next(action);
};

export default localStorageMiddleware;
